import parseHTML from "../lib/dom/funciones/parse_html";

const testimonios = () => {
    [].forEach.call(document.querySelectorAll('.testimonios__testimonios'), (carrusel: HTMLElement) => {
        const elementos = Array.from(carrusel.querySelectorAll<HTMLElement>('.testimonios__testimonio'));

        const ajustaAlturas = () => {
            const rectDeCarrusel = carrusel.getBoundingClientRect();
            const visibles = elementos.filter(e => {
                return e.getBoundingClientRect().left >= rectDeCarrusel.left - 10 && e.getBoundingClientRect().right <= rectDeCarrusel.right + 10;
            });

            const alturaMaxima = Math.max(...visibles.map(e => e.getBoundingClientRect().height));
            carrusel.style.height = `${alturaMaxima}px`;
        };

        const navegacion = parseHTML('<nav class="testimonios__navegacion"></nav>') as HTMLElement;
        carrusel.insertAdjacentElement('afterend', navegacion);

        const anterior = parseHTML('<button class="testimonios__anterior" aria-label="Testimonio anterior">Anterior</button>') as HTMLButtonElement;
        const siguiente = parseHTML('<button class="testimonios__siguiente" aria-label="Testimonio siguiente">Siguiente</button>') as HTMLButtonElement;
        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);

        const desplaza = (direccion: number) => () => {
            const rectDeCarrusel = carrusel.getBoundingClientRect();

            carrusel.scrollTo({left: carrusel.scrollLeft + rectDeCarrusel.width * direccion, behavior: 'smooth'});
        };

        anterior.addEventListener('click', desplaza(-1));
        siguiente.addEventListener('click', desplaza(1));

        const actualizaBotones = () => {
            anterior.disabled = carrusel.scrollLeft <= 0;
            siguiente.disabled = carrusel.scrollLeft + carrusel.clientWidth >= carrusel.scrollWidth - 1;

            if (anterior.disabled && siguiente.disabled) {
                navegacion.style.display = 'none';
            } else {
                navegacion.style.display = 'flex';
            }
        }

        carrusel.addEventListener('resize', actualizaBotones);
        carrusel.addEventListener('scroll', actualizaBotones);
        actualizaBotones();
    });
};

export default testimonios;